export function getInboxMenu() {
    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var results = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];


    var byApp = {},
        byType = {},
        byOwner = {};

    var byRoot = {
        title: "Inbox",
        url: root,
        count: 0
    };

    results.forEach(function (item) {
        var appName = item.appName,
            inboxType = item.inboxType,
            ownerName = item.ownerName;


        if (appName) {

            if (!byApp[appName]) {
                byApp[appName] = {
                    title: appName,
                    url: root + "/app/" + appName,
                    count: 0
                };
            }

            byApp[appName].count++;
        }

        if (inboxType) {

            if (!byType[inboxType]) {
                byType[inboxType] = {
                    title: inboxType,
                    url: root + "/type/" + inboxType,
                    count: 0
                };
            }

            byType[inboxType].count++;
        }

        if (ownerName) {

            if (!byOwner[ownerName]) {
                byOwner[ownerName] = {
                    title: ownerName,
                    url: root + "/owner/" + ownerName,
                    count: 0
                };
            }

            byOwner[ownerName].count++;
        }

        byRoot.count++;
    });

    var menu = [byRoot];

    if (byApp) {

        menu.push({
            title: "By app",
            url: root + "/app",
            children: Object.values(byApp),
            count: Object.values(byApp).length
        });
    }

    if (byOwner) {

        menu.push({
            title: "By owner",
            url: root + "/owner",
            children: Object.values(byOwner),
            count: Object.values(byOwner).length
        });
    }

    if (byType) {

        menu.push({
            title: "By type",
            url: root + "/type",
            children: Object.values(byType),
            count: Object.values(byType).length
        });
    }

    return menu;
}